// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__n2Tge","tabsButton":"Tabs_tabsButton__rrLHp","tabsCount":"Tabs_tabsCount__DpTU2"};